
(function () {
  'use strict';

  var SEKCJE = '.bh-promo, .bh-team, .bh-categories, .bh-trust, .bh-knowledge, .bh-brands, .bh-about';
  var KARTY = '.bh-hit, .bh-promo__cell, .bh-cat, .bh-trust__item, .bh-guide, .bh-films__cell, .bh-brand';
  var MAX_KART = 8;

  function bezRuchu() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  var obserwator = null;

  function pokaz(el) {
    el.classList.add('bh-reveal--widoczna');
  }

  function przygotuj(sekcja) {
    if (sekcja.classList.contains('bh-reveal')) return;
    sekcja.classList.add('bh-reveal');

    var karty = [].slice.call(sekcja.querySelectorAll(KARTY));
    for (var i = 0; i < karty.length && i < MAX_KART; i += 1) {
      karty[i].style.setProperty('--bh-reveal-i', String(i));
    }
    if (obserwator) obserwator.observe(sekcja);
  }

  function uruchom(zakres) {
    if (bezRuchu()) return;
    if (!('IntersectionObserver' in window)) return;

    if (!obserwator) {
      obserwator = new IntersectionObserver(function (wpisy) {
        for (var i = 0; i < wpisy.length; i += 1) {
          if (!wpisy[i].isIntersecting) continue;
          pokaz(wpisy[i].target);
          obserwator.unobserve(wpisy[i].target);
        }
      }, {
        threshold: 0,
        rootMargin: '0px 0px 100% 0px'
      });
    }

    var sekcje = (zakres || document).querySelectorAll(SEKCJE);
    for (var s = 0; s < sekcje.length; s += 1) przygotuj(sekcje[s]);
  }

  function odepnij(zakres) {
    var sekcje = (zakres || document).querySelectorAll(SEKCJE);
    for (var i = 0; i < sekcje.length; i += 1) {
      if (obserwator) obserwator.unobserve(sekcje[i]);
      sekcje[i].classList.remove('bh-reveal', 'bh-reveal--widoczna');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { uruchom(); });
  } else {
    uruchom();
  }

  document.addEventListener('shopify:section:load', function (ev) { uruchom(ev.target); });
  document.addEventListener('shopify:section:unload', function (ev) { odepnij(ev.target); });
}());
